import { xNormed } from 'ml-spectra-processing';
/**
 * Norm the Y values
 * @param data
 */
export function normed(data, options = {}) {
    xNormed(data.y, { ...options, output: data.y });
    return { data };
}
//# sourceMappingURL=normed.js.map